export const messages = {
  en: {
    reportCustomComponentFooterManage: {
      statistics: 'Statistics',
      id: 'ID',
      name: 'Name',
      queryMethod: 'Query Method',
      description: 'Description',
      fetchError: 'Failed to fetch footer list'
    }
  },
  zh: {
    reportCustomComponentFooterManage: {
      statistics: '统计',
      id: 'ID',
      name: '名称',
      queryMethod: '查询方式',
      description: '描述',
      fetchError: '获取页脚列表失败'
    }
  }
}